// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__d0L4k","icon":"SearchBar_icon__xTgYa","input":"SearchBar_input__MVjeN"};